import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClientService } from '@core/service/client.service';
import { Client } from '@core/model/client.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class ClientComponent implements OnInit {
  clientForm: FormGroup;
  clients: Client[];

  constructor(
    private formBuilder: FormBuilder,
    private clientService: ClientService
  ) {}

  ngOnInit() {
    this.createForm();
    this.listClient();
  }
  createForm() {
    this.clientForm = this.formBuilder.group({
      nombres: ['', [Validators.required]],
      apellidos: ['', [Validators.required]],
      ci_nit: ['', [Validators.required]],
      direccion: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      // latitud: ['', [Validators.required]],
      // longitud: ['', [Validators.required]],
      foto: ['', [Validators.required]],
      celular: ['', [Validators.required]]
    });
  }
  listClient() {
    this.clientService.getAll().subscribe(
      data => {
        this.clients = data;
        console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  registerClient() {
    const newClient: Client = new Client();
    newClient.nombres = this.clientForm.value.nombres;
    newClient.apellidos = this.clientForm.value.apellidos;
    newClient.ci_nit = this.clientForm.value.ci_nit;
    newClient.direccion = this.clientForm.value.direccion;
    newClient.email = this.clientForm.value.email;
    newClient.foto = this.clientForm.value.foto;
    newClient.celular = this.clientForm.value.celular;
    // newClient.latitud=this.clientForm.value.latitud;
    // newClient.longitud=this.clientForm.value.longitud;
    newClient.email = this.clientForm.value.email;

    this.clientService.create(newClient).subscribe(
      data => {
        Swal.fire(data);
        this.clientForm.reset();
        this.listClient();
      },
      error => {
        Swal.fire(error.error);
      }
    );
  }

  /* enableClient(id: number) {
    this.clientService.enableClient(id).subscribe(
      data => {
        this.listClient();
      },
      error => {
        console.log(error.error);
      }
    );
  }*/
}
